const palettes = ['red', 'blue', 'green', 'indigo', 'purple', 'pink', 'orange', 'olive', 'daka', 'legalmente', 'pastel'];

export default palettes;
